var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "settings-editor-base",
    { attrs: { label: _vm.label } },
    [
      [
        _c(
          "div",
          { staticClass: "position-picker-positions" },
          _vm._l(_vm.positions, function(position) {
            return _c("div", {
              key: position.key,
              staticClass: "position",
              class: position.classes,
              attrs: { "data-toggle": "tooltip", title: position.tooltip },
              on: {
                click: function($event) {
                  return _vm.$emit("input", position.key)
                }
              }
            })
          }),
          0
        )
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }